// extracted by mini-css-extract-plugin
export default {"root":"switchLanguage_root__aMQ9e","lan":"switchLanguage_lan__L57+f","choose":"switchLanguage_choose__QYujL"};